<template>
  <div class="base-form">
    <el-form-item :label="$t('i18n.b985c54ec0b64c37852c22562475f1ce')" prop="name">
      <el-input
        v-model="form.name"
        maxlength="50"
        show-word-limit
        :placeholder="$t('i18n.a6d61a9d34474ef5bcbb83938e05c756')"
      ></el-input>
    </el-form-item>
    <el-form-item :label="$t('certificate_staff_17')" prop="fileType">
      <el-checkbox-group v-model="form.fileType">
        <el-checkbox v-for="item in uploadFileType" :key="item" :label="item"></el-checkbox>
      </el-checkbox-group>
    </el-form-item>
    <el-form-item :label="$t('i18n.b598cc8dc7fd42859b7c679fb8aa7c09')" prop="maxUploadFiles">
      <span>{{ $t('471c8334') }}</span>
      <el-input-number
        class="short-select"
        v-model="form.maxUploadFiles"
        controls-position="right"
        :min="1"
        :max="10"
      ></el-input-number>
      <span>{{ $t('71c83341') }}</span>
    </el-form-item>
    <el-form-item class="inline" prop="maxUploadSize">
      <span>{{ $t('i18n.593e6d1a5b1941ea844e38afefe65b7d') }}</span>
      <el-input-number
        class="short-select"
        v-model="form.maxUploadSize"
        controls-position="right"
        :min="1"
        :max="10"
      ></el-input-number>
      <span>MB</span>
    </el-form-item>
    <el-form-item :label="$t('i18n.0a5d225866204083972f74127963080b')" prop="region">
      <el-checkbox v-model="form.require">{{ $t('i18n.ca2f54a11aaf46d49f46588e55bbab1a') }}</el-checkbox>
    </el-form-item>
  </div>
</template>

<script>
import { uploadFileType } from '../../enum'
export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      // 文件上传类型
      uploadFileType
    }
  }
}
</script>

<style scoped lang="scss">
.base-form {
  font-size: 14px;
  color: #595959;
  .short-select {
    width: 85px;
  }
}
</style>
